"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeAcceptedFileTypesText = void 0;
var _lodash = require("lodash");
var _utils = require("../../utils");
var composeAcceptedFileTypesText = function composeAcceptedFileTypesText() {
  var acceptedFileTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fileExtension = arguments.length > 1 ? arguments[1] : undefined;
  var supportedTypesPartial = 'Please use any of supported ones:' + acceptedFileTypes.map(function (item) {
    return '.' + item.split('/')[1];
  }).join(', ');

  // The file extension that we check here is the actual one, derived from the image to be loaded
  // Antd Upload does not identify it correctly, if the file was corrupted by manually changing extension
  // This case needs more specific error messages, to give user more info on the situation

  if (!fileExtension) {
    return "Unsupported non-image file type. ".concat(supportedTypesPartial);
  }
  if ((0, _lodash.includes)(_utils.OTHER_POSSIBLE_IMAGE_EXTENSIONS, fileExtension)) {
    return "The image you\u2019ve provided has a .".concat(fileExtension, " type and is not supported. ").concat(supportedTypesPartial);
  }
  if (!(0, _lodash.includes)(acceptedFileTypes, fileExtension)) {
    return "The file you\u2019ve provided is not an image file. ".concat(supportedTypesPartial);
  }
  return "Unsupported image file type. ".concat(supportedTypesPartial);
};
exports.composeAcceptedFileTypesText = composeAcceptedFileTypesText;